import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { jwtDecode } from 'jwt-decode';
import { loginUser } from '../services/api';

import { Button } from "../components/ui/Button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../components/ui/Card";
import { Input } from "../components/ui/Input";
import { Label } from "../components/ui/Label";
import { Eye, EyeOff } from 'lucide-react'; // Importar ícones

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false); // Estado para visibilidade da senha
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const data = await loginUser({ email, senha: password });
            
            let userRole = null;
            if (data.jwt) {
                try {
                    const decodedToken = jwtDecode(data.jwt);
                    if (decodedToken.roles && decodedToken.roles.length > 0) {
                        userRole = decodedToken.roles[0];
                    }
                } catch (decodeError) {
                    console.error("Erro ao decodificar JWT:", decodeError);
                }
            }

            login(data.jwt, data.idParticipante, data.nomeParticipante, userRole);
            navigate('/dashboard');

        } catch (err) {
            console.error('Erro de login:', err.message);
            setError(err.message || 'Ocorreu um erro ao tentar fazer login.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-background">
            <Card className="w-full max-w-sm">
                <CardHeader className="text-center">
                    <img src="/ucm-logo.png" alt="Gestão de Presenças Logo" className="w-24 h-auto mx-auto mb-4" />
                    <p className="text-sm text-muted-foreground mb-2">Universidade Católica de Moçambique</p>
                    <CardTitle className="text-2xl">Gestão de Presenças</CardTitle>
                </CardHeader>
                <form onSubmit={handleLogin}>
                    <CardContent className="grid gap-4">
                        {error && <p className="text-sm font-medium text-destructive">{error}</p>}
                        <div className="grid gap-2">
                            <Label htmlFor="email" className="mb-1">Email</Label> {/* Adicionado mb-1 */}
                            <Input
                                id="email"
                                type="email"
                                placeholder="m@exemplo.com"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                        <div className="grid gap-2">
                            <div className="flex items-center">
                                <Label htmlFor="password" className="mb-1">Senha</Label> {/* Adicionado mb-1 */}
                                <Link to="/forgot-password" className="ml-auto inline-block text-sm underline transition-colors hover:text-primary"> {/* Adicionado transições */}
                                    Esqueceu a senha?
                                </Link>
                            </div>
                            <div className="relative">
                                <Input
                                    id="password"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Sua senha"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    disabled={isLoading}
                                    className="pr-10" // Adiciona padding para o ícone
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-muted-foreground hover:text-primary transition-colors" // Adicionado transições
                                    disabled={isLoading}
                                >
                                    {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                                </button>
                            </div>
                        </div>
                    </CardContent>
                    <CardFooter className="flex flex-col">
                        <Button className="w-full" type="submit" disabled={isLoading}>
                            {isLoading ? 'A entrar...' : 'Entrar'}
                        </Button>
                        <p className="mt-4 text-xs text-center text-muted-foreground">
                            Ainda não tem conta?{" "}
                            <Link to="/register" className="underline transition-colors hover:text-primary"> {/* Adicionado transições */}
                                Cadastre-se aqui
                            </Link>
                        </p>
                    </CardFooter>
                </form>
            </Card>
        </div>
    );
}

export default LoginPage;